import { render, staticRenderFns } from "./itemReleaseFinishList.vue?vue&type=template&id=4828f64f&scoped=true"
import script from "./itemReleaseFinishList.vue?vue&type=script&lang=js"
export * from "./itemReleaseFinishList.vue?vue&type=script&lang=js"
import style0 from "./itemReleaseFinishList.vue?vue&type=style&index=0&id=4828f64f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4828f64f",
  null
  
)

export default component.exports